import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import {
  CreateUnavailabilityPeriodRequest,
  UnavailabilityPeriod,
} from './types'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

/**
 * Hook to create a new unavailability period
 */
export const useCreateUnavailabilityPeriod = () => {
  const fetchWithAuth = useFetchWithAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (
      data: CreateUnavailabilityPeriodRequest
    ): Promise<UnavailabilityPeriod> => {
      const response = await fetchWithAuth(`${URL}/profile/unavailability`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
      return response
    },
    onSuccess: () => {
      // Invalidate the unavailability periods query to refetch the data
      queryClient.invalidateQueries({ queryKey: ['unavailabilityPeriods'] })
      toast.success('Unavailability period created successfully')
    },
    onError: (error) => {
      console.error('Error creating unavailability period:', error)
      toast.error(error.message || 'Failed to create unavailability period')
    },
  })
}
